export default __webpack_public_path__ + "static/highlight-4-f2880cf669f07bfa6142c7a5dd725702.svg";